// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tag[data-v-346efa17]{display:flex;align-items:center;color:var(--primary-color);background-color:#fff;margin:0 8px 8px 0;text-decoration:none;text-align:center;border:none;cursor:pointer}.tag[data-v-346efa17]:hover{color:var(--secondary-color)}.icon[data-v-346efa17]{margin-right:4px}", ""]);
// Exports
module.exports = exports;
